import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

/**
 * Keeps <html lang="..."> in sync with the active i18n language and
 * with the URL language prefix.
 */
const SUPPORTED = ["it", "en", "ja"];

const useSyncHtmlLang = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  // Sync i18n language from URL prefix (source of truth)
  useEffect(() => {
    const segs = location.pathname.split("/").filter(Boolean);
    const urlLang = ["en", "ja"].includes(segs[0]) ? segs[0] : "it";
    if (urlLang !== i18n.language && SUPPORTED.includes(urlLang)) {
      i18n.changeLanguage(urlLang);
    }
  }, [location.pathname, i18n]);

  // Sync <html lang> attribute
  useEffect(() => {
    const apply = (lng) => {
      const short = (lng || "it").slice(0, 2);
      if (typeof document !== "undefined" && document.documentElement) {
        document.documentElement.setAttribute("lang", short);
      }
    };
    apply(i18n.resolvedLanguage || i18n.language);
    i18n.on("languageChanged", apply);
    return () => i18n.off("languageChanged", apply);
  }, [i18n]);
};

export default useSyncHtmlLang;
